<po-page-default p-title="Notas e Faturamento - Domínio" [p-breadcrumb]="breadcrumb"
  p-subtitle="Gere o relatório de Notas e Faturamento com base nas informações da base de dados do sistema Domínio.">
  <form #form="ngForm" (ngSubmit)="requestNotasFaturamento(form)">
    <div class="po-row">
      <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
        <span class="an an-robot"></span>
        Configurações do Relatório
      </span>

      <div class="po-row">
        <po-container class="po-lg-12 po-md-12 po-sm-12">
          <div class="po-lg-11 po-md-9 po-sm-8">
            <p class="po-font-subtitle">Notas e Faturamento - Configure a geração do seu relatório</p>
            <br />
            <br />
          </div>
          <div class="po-row">
            <app-empresa-combo class="po-lg-4" name="idEmpresa" [(ngModel)]="idEmpresa"
              label="Empresa" p-required="true"
              placeholder="Buscar por código ou nome da empresa..."
              help="Digite o código (Domínio) ou o nome da empresa para buscar.">
            </app-empresa-combo>
            <po-datepicker-range class="po-lg-3" p-label="Período" p-name="periodo" p-placeholder="Período"
              name="periodo" [(ngModel)]="periodo" p-placeholder-start="Data Início"
              p-placeholder-end="Data Fim" p-help="Informe o período desejado para o relatório (formato US: YYYY-MM-DD)"
              [p-required]="true">
            </po-datepicker-range>
          </div>

          <div class="po-row">
            <po-button class="po-lg-3 po-mt-4" p-label="Gerar Relatório de Notas e Faturamento"
              (p-click)="requestNotasFaturamento(form)" [p-loading]="isLoading">
            </po-button>
          </div>

          <br />
          <div class="po-lg-11 po-md-9 po-sm-8">
            <br />
            <p class="po-font-text-large">
              Nesta etapa o sistema usará as informações do banco de dados do sistema Domínio para gerar o relatório de Notas e Faturamento.
              <br />
              <br />
            </p>
            <p class="po-font-text-large">
              Depois de processado, <b class="text-green">enviará um e-mail com o relatório para o e-mail cadastrado em seu usuário</b>,
              e esse processo poderá demorar alguns minutos.
              <br />
            </p>
          </div>
        </po-container>
      </div>
    </div>
  </form>
</po-page-default>
